import type { ComponentPropsWithoutRef, ReactNode } from "react";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

export interface SidebarHeaderProps extends ComponentPropsWithoutRef<"header"> {
  children: ReactNode;
  className?: string;
}

export const SidebarHeader = ({
  className,
  children,
  ...rest
}: SidebarHeaderProps) => (
  <header
    className={classNames(
      "flex h-[3.5rem] items-center justify-between px-6 py-3",
      className,
    )}
    data-testid="builder-ui-sidebar-header"
    {...rest}
  >
    {children}
  </header>
);
